import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c67a54ca"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "bg-topic"
};
const _hoisted_2 = {
  class: "default-padding",
  "element-loading-background": "transparent"
};
const _hoisted_3 = {
  key: 0,
  class: "top-warp"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "title-warp"
};
const _hoisted_6 = {
  class: "action-title"
};
const _hoisted_7 = {
  class: "total"
};
const _hoisted_8 = {
  class: "movies-list"
};
const _hoisted_9 = {
  key: 1,
  class: "pagination"
};
const _hoisted_10 = {
  class: "page-span"
};
import { axiosInstanceAll } from '@/api/instance';
import { vodPlusBaseUrl } from '@/utils';
import { inject, onMounted } from 'vue';
import MoviesOrActorItem from './moviesOrActorItem.vue';
import OtherMOAItem from './otherMOAItem.vue'; // const props = defineProps({
//   modelValue: {
//     type: Boolean,
//     default: false
//   },
// })

export default /*#__PURE__*/_defineComponent({
  __name: 'bgTopic',
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const searchParams = reactive({
      searchValue: '',
      loading: false,
      paginationConfig: {
        page: 0,
        limit: 12,
        total: 0
      }
    });
    const moviesList = ref([]);

    const getData = async () => {
      console.log('get Data');
      moviesList.value = [];
      searchParams.loading = true;

      try {
        const {
          programListUrl
        } = currentParams.value;
        const res = await axiosInstanceAll({
          method: 'get',
          url: '/vodPlus' + programListUrl.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken'),
            start: searchParams.paginationConfig.page * searchParams.paginationConfig.limit,
            total: searchParams.paginationConfig.limit
          }
        });
        console.log(res);

        if (res.status == 200) {
          moviesList.value = res.data.list;
          searchParams.paginationConfig.total = res.data.totalNum;
        }
      } catch (error) {}

      searchParams.loading = false;
    };

    const handlePaginationChange = val => {
      searchParams.paginationConfig.page = val - 1;
      getData();
    };

    const infoItemClick = item => {
      emit('onCardClick', item);
    };

    onMounted(() => {
      getData();
    });
    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentParams = inject('currentParams');
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [true ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(currentParams).background ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "bg-warp",
        style: _normalizeStyle(_unref(currentParams).background && 'background: url(' + _unref(currentParams).background + ')no-repeat; background-size: 100% 100%;')
      }, null, 4)) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [!searchParams.loading ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(currentParams).name), 1), _createElementVNode("span", _hoisted_7, _toDisplayString('المجموع') + ": " + _toDisplayString(searchParams.paginationConfig.total), 1)])]), _createElementVNode("div", _hoisted_8, [_unref(currentUiStyleOptions).styleName == 'default' || _unref(currentUiStyleOptions).styleName == 'arabic' ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(moviesList.value, (item, index) => {
        return _openBlock(), _createBlock(MoviesOrActorItem, {
          infoItem: item,
          poster: item.image,
          "program-name": item.name,
          rating: item.rating,
          onClick: $event => infoItemClick(item)
        }, null, 8, ["infoItem", "poster", "program-name", "rating", "onClick"]);
      }), 256)) : _createCommentVNode("", true), _unref(currentUiStyleOptions).styleName == 'style2' ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(moviesList.value, (item, index) => {
        return _openBlock(), _createBlock(OtherMOAItem, {
          onClick: $event => _ctx.itemClick(item),
          infoItem: item
        }, null, 8, ["onClick", "infoItem"]);
      }), 256)) : _createCommentVNode("", true), !moviesList.value.length && !searchParams.loading ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 2,
        description: "لا توجد بيانات",
        style: {
          "width": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), !searchParams.loading && searchParams.paginationConfig.total > searchParams.paginationConfig.limit ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_pagination, {
        small: "",
        background: "",
        layout: "prev, pager, next, slot",
        "current-page": searchParams.paginationConfig.page + 1,
        "page-size": searchParams.paginationConfig.limit,
        total: searchParams.paginationConfig.total,
        onCurrentChange: handlePaginationChange
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_10, _toDisplayString(searchParams.paginationConfig.page * searchParams.paginationConfig.limit + 1 + '-' + (searchParams.paginationConfig.total / (searchParams.paginationConfig.page + 1) > searchParams.paginationConfig.limit ? (searchParams.paginationConfig.page + 1) * searchParams.paginationConfig.limit : searchParams.paginationConfig.total)) + " of " + _toDisplayString(searchParams.paginationConfig.total) + " items ", 1)]),
        _: 1
      }, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)])), [[_directive_loading, searchParams.loading]])], 64)) : _createCommentVNode("", true)]);
    };
  }

});